module.exports = __webpack_public_path__ + "img/Wp_2084.f159c165.png";